import { Box } from '@origin-digital/layout';
import { Colors } from '@origin-digital/style-guide';
import * as React from 'react';
import styled from 'styled-components';
import { getHomepageUrl } from '../config/ConfigService';
import { OriginLogoAnimated } from './OriginLogoAnimated';

interface IHeaderProps {
  className?: string;
}

const StyledLogo = styled(OriginLogoAnimated)`
  padding: 4px;
  width: 56px;
  height: 56px;
`;

const Header: React.FC<IHeaderProps> = ({ className }) => (
  <header data-id="app-header" className={className}>
    <StyledLink className="logo" href={getHomepageUrl()} data-id="logo">
      <Box color={Colors.WHITE} width={64} height={64} data-id="header-box">
        <StyledLogo />
      </Box>
    </StyledLink>
  </header>
);

const StyledHeader = styled(Header)`
  background: ${Colors.WHITE};
  height: 64px;
  min-height: 64px;
  width: 100vw;
`;

const StyledLink = styled.a`
  display: block;
  width: 64px;
`;

export { StyledHeader as Header };
